import React from "react";
import { StyleSheet, StyleProp, ViewStyle } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { useTheme } from "@/hooks/useTheme";

interface HeroSectionProps {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  gradientColors?: string[];
  padding?: number;
  minHeight?: number;
}

export function HeroSection({ children, style, gradientColors, padding = 24, minHeight = 120 }: HeroSectionProps) {
  const { colors } = useTheme();

  const defaultGradientColors = gradientColors || [colors.primary, colors.secondary || colors.primary];

  return (
    <LinearGradient
      colors={defaultGradientColors as [string, string, ...string[]]}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
      style={[
        styles.hero,
        {
          padding,
          minHeight,
        },
        style,
      ]}
    >
      {children}
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  hero: {
    justifyContent: "center",
  },
});
